import {createAsyncThunk, createSlice, PayloadAction} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'
import {useSelector} from 'react-redux'
import {HostMaps} from 'hiya-common/src/utils/host/AutoHost'

export const get_simple_member_by_mid = createAsyncThunk(
  'NewAnchorCenter/get_simple_member_by_mid',
  async (mid: number, store: any) => {
    const resp = await http.post('/live/account/simple_member_by_mid', {
      ...store.getState().env.deviceinfo,
      mid,
    })
    return resp.data.data
  }
)
export const get_room_by_id = createAsyncThunk(
  'NewAnchorCenter/get_room_with_room_id',
  async (room_id: number, store: any) => {
    const resp = await http.post('/live/room/get_room_with_room_id', {
      ...store.getState().env.deviceinfo,
      room_id,
    })
    return resp.data.data
  }
)

// 获取直播周期
export const getLiveCenterPeriod = createAsyncThunk(
  'NewAnchorCenter/getLiveCenterPeriod',
  async (p: any, store: any) => {
    const resp = await http.post('/live/union/settle_cfg', {
      ...store.getState().env.deviceinfo,
      ...p,
    })
    return resp.data.data
  }
)
export const get_anchor_info_by_mid = createAsyncThunk(
  'NewAnchorCenter/get_anchor_info_by_mid',
  async (p: any, store: any) => {
    const resp = await http.post('/live/union/get_anchor_info_by_mid', {
      ...store.getState().env.deviceinfo,
      ...p,
    })
    return resp.data.data
  }
)
export const getLiveInfoTabV2 = createAsyncThunk(
  'NewAnchorCenter/live_info_tab_v2',
  async (p: any, store: any) => {
    const resp = await http.post('/live/union/live_info_tab_v2', {
      ...store.getState().env.deviceinfo,
      ...p,
    })
    return resp.data.data
  }
)
export const get_settle_anchor_salary_overview = createAsyncThunk(
  'NewAnchorCenter/settle_anchor_salary_overview',
  async (p: any, store: any) => {
    const resp = await http.post('/live/union/settle_anchor_salary_overview', {
      ...store.getState().env.deviceinfo,
      ...p,
    })
    return resp.data.data
  }
)
export const get_live_detail_daily = createAsyncThunk(
  'NewAnchorCenter/live_detail_daily',
  async (p: any, store: any) => {
    const resp = await http.post('/live/union/live_detail_daily', {
      ...store.getState().env.deviceinfo,
      ...p,
    })
    return resp.data.data
  }
)
export const get_live_detail_by_session_gift = createAsyncThunk(
  'NewAnchorCenter/live_detail_by_session_gift',
  async (p: any, store: any) => {
    const resp = await http.post('/live/union/live_detail_by_session_gift', {
      ...store.getState().env.deviceinfo,
      ...p,
      page_size: 100,
      offset: 0,
    })
    return resp.data.data
  }
)

export const get_live_detail_by_session_other = createAsyncThunk(
  'NewAnchorCenter/live_detail_by_session_other',
  async (p: any, store: any) => {
    const resp = await http.post('/live/union/live_detail_by_session', {
      ...store.getState().env.deviceinfo,
      ...p,
      page_size: 100,
      offset: 0,
    })
    return resp.data.data
  }
)
export const get_settle_policy = createAsyncThunk(
  'NewAnchorCenter/settle_policy',
  async (p: any, store: any) => {
    const resp = await http.post('/live/union/settle_policy', {
      ...store.getState().env.deviceinfo,
      ...p,
    })
    return resp.data.data
  }
)
export const get_live_diamond_record_list = createAsyncThunk(
  'NewAnchorCenter/live_diamond_record_list',
  async (p: any, store: any) => {
    const resp = await http.post('/live/union/live_diamond_record_list', {
      ...store.getState().env.deviceinfo,
      ...p,
      page_size: 1000,
      offset: 0,
    })
    return resp.data.data
  }
)
export const get_settle_anchor_salary_list = createAsyncThunk(
  'NewAnchorCenter/settle_anchor_salary_list',
  async (p: any, store: any) => {
    const resp = await http.post('/live/union/settle_anchor_salary_list', {
      ...store.getState().env.deviceinfo,
      ...p,
      page_size: 1000,
      offset: 0,
    })
    return resp.data.data
  }
)

export interface InitialStateType {
  home: any
  detail: {
    info: any
  }
  sessionDetail: {
    info: any
  }
  homeTransData: {
    id?: number // 主播经历唯一标识
    mid?: number // 查看谁的信息
    tRange?: string // 时间范围
    unionId?: number // 公会id
  }
  base: {
    periodList?: Array<any>
  }
  diamondQueryList: Array<any>
  policyList: Array<any>
  salaryDetailList: Array<any>
}

const initialState: InitialStateType = {
  home: {},
  detail: {
    info: {},
  },
  sessionDetail: {
    info: {},
  },
  homeTransData: {},
  base: {
    periodList: [],
  },
  diamondQueryList: [],
  policyList: [],
  salaryDetailList: [],
}

export const NewAnchorCenterSlice = createSlice({
  name: 'NewAnchorCenterSlice',
  initialState,
  reducers: {
    updateHomeTransData: (state, action: PayloadAction<any>) => {
      const {homeTransData} = state
      Object.assign(state, {
        homeTransData: {
          ...homeTransData,
          ...action.payload,
        },
      })
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getLiveCenterPeriod.fulfilled, (state, action) => {
      const {base} = state
      const {list = []} = action.payload
      Object.assign(state, {
        base: {
          ...base,
          periodList: list.map((item, index) => {
            return {text: item, value: item, index}
          }),
        },
      })
    })
    builder.addCase(getLiveInfoTabV2.fulfilled, (state, action) => {
      const {home} = state
      Object.assign(state, {
        home: {
          ...home,
          ...action.payload,
        },
      })
    })
    builder.addCase(
      get_settle_anchor_salary_overview.fulfilled,
      (state, action) => {
        const {home} = state
        Object.assign(state, {
          home: {
            ...home,
            ...action.payload,
          },
        })
      }
    )
    builder.addCase(get_live_detail_daily.fulfilled, (state, action) => {
      const {detail} = state
      const {list = []} = action.payload
      Object.assign(state, {
        detail: {
          ...detail,
          info: list[0],
        },
      })
    })
    builder.addCase(
      get_live_detail_by_session_other.fulfilled,
      (state, action) => {
        const {sessionDetail} = state
        const {list = []} = action.payload
        Object.assign(state, {
          sessionDetail: {
            ...sessionDetail,
            info: list[0],
          },
        })
      }
    )
    builder.addCase(get_settle_policy.fulfilled, (state, action) => {
      const {list = []} = action.payload
      Object.assign(state, {
        policyList: list,
      })
    })
    builder.addCase(get_live_diamond_record_list.fulfilled, (state, action) => {
      const {list = []} = action.payload
      Object.assign(state, {
        diamondQueryList: list,
      })
    })
    builder.addCase(
      get_settle_anchor_salary_list.fulfilled,
      (state, action) => {
        const {list = []} = action.payload
        Object.assign(state, {
          salaryDetailList: list,
        })
      }
    )
  },
})
export default NewAnchorCenterSlice.reducer
export const NewAnchorCenterActions = NewAnchorCenterSlice.actions

export const useNewAnchorCenterState = () => {
  const data = useSelector((state) => {
    return state.NewAnchorcenter
  })
  return data
}
